import { render, staticRenderFns } from "./PrivacyPolicy2018.vue?vue&type=template&id=8f859baa&"
import script from "./PrivacyPolicy2018.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicy2018.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8f859baa', component.options)
    } else {
      api.reload('8f859baa', component.options)
    }
    module.hot.accept("./PrivacyPolicy2018.vue?vue&type=template&id=8f859baa&", function () {
      api.rerender('8f859baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/flatpages/PrivacyPolicy2018.vue"
export default component.exports